// removed by extract-text-webpack-plugin
module.exports = {"errorText":"style__errorText___24E7l"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/uq-forms/components/form-errors/style.css
// module id = 688
// module chunks = 0